<template>
  <ion-page>
    <ion-content style="--ion-background-color: white !important;">
      <div style="text-align:center; margin: 15px;" data-header-ad-wrapper>
        <VueScriptComponent v-if="adLinkTop && adLinkTop !=''" :script="adLinkTop" />
      </div>
        <ion-grid>
          <ion-row>
            <ion-col>
                <div class="cf wrap noTop">
                <div class="controls cf">
                  <div class="refresh-bar">
                    <span class="refresh-label">Aktualisierung</span>

                    <select name="refresh" class="refresh-select" v-model="selectedRefresh">
                      <option v-for="refresh in refreshSelect" :key="refresh.id" :value="refresh.id">
                        {{ refresh.name }}
                      </option>
                    </select>

                    <button type="button" class="refresh-button" @click="refreshScore()" title="Aktualisieren">
                      ↻
                    </button>
                  </div>
                </div>
              </div>
            </ion-col>
          </ion-row>
          <ion-row class="ion-no-margin ion-no-padding">
            <div class="score-header">
              
              <div class="score-controls">
                
                <select
                  v-if="scoringMode != 3 && viewType.length > 1"
                  class="query round-select"
                  v-model="selectedViewType"
                >
                  <option v-for="vType in viewType" :key="vType.id" :value="vType.id">
                    {{ vType.name }}
                  </option>
                </select>

                <select
                  v-if="selectedViewType == 1"
                  class="round-select"
                  v-model="selectedSingleRound"
                >
                  <option v-for="round in singleScoresRounds" :key="round.id" :value="round.id">
                    {{ $t('round') }} {{ round.roundIndex }}
                  </option>
                </select>

              </div>

              <div class="tournament-title-wrapper">
                <img class="tournament-logo" :src="logoImg">
                <h3 v-if="matchDays" class="tournament-title">
                  {{ matchDays[0].name }}
                </h3>
              </div>

            </div>
          </ion-row>
          <ion-row  v-if="currentTicker && currentTicker.tickerText != ''">
            <ion-col>
              <marquee-text class="ticker-text" :key="currentTicker.id" :duration="8" :repeat="15">
                {{ currentTicker.tickerText }}&nbsp; &nbsp; &nbsp; 
              </marquee-text>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-grid style="color: black;" v-if="teamScores.length == 0 && singleScoresRounds.length == 0 && !getDGVTeamScoreLoading && !getDGVSingleScoreLoading">
          <ion-row>
            <ion-col>
              <div class="head">
                <p>{{ $t('noScoresFound') }}</p>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>

        <ion-grid style="color: black;" v-if="scoringMode != 3 && teamScores.length > 0 && selectedViewType == 0"> <!-- Team View -->
          <ion-row>
            <ion-col>

              <div v-for="(team, index) in teamScores" :key="index" :value="team">
                <div class="head">
                  <span class="rank">{{ team.rank }}</span><span class="club">{{ team.name  }}</span><span class="score">{{ getSign(team.totalScore)    }}{{ team.totalScore  }}</span>
                </div>

                <div  v-for="round in team.rounds" :key="round" :value="round">
                  <div class="roundInfo">Runde {{ round.roundIndex  }} -  {{ round.playForm  }}</div>

                  <table class="ranking">
                      <thead>
                      <tr>
                      <th>Name</th>
                      <th>Club</th>
                      <th>HCPI&#8482;</th>
                      <th>+/-</th>
                      <th>{{ $t('thru') }}</th>
                      <th>{{ $t('total') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                        <template v-for="player in round.players" :key="player">
                          <tr :class="player.partnerNum == 2 ? 'teamEnd' : ''">
                            <td style="width: 20%"><span @click="player.showScorecard = !player.showScorecard">{{ player.name }}</span></td>
                            <td>{{ player.clubName }}</td>
                            <td>{{ player.hcp }}</td>
                            <td>{{ player.partnerNum == 2 ? '' : player.showTeetime != '' ? player.showTeetime : player.isStreicher ? '(' + getPlusSign(player.score) + ')' : getPlusSign(player.score) }}</td>
                            <td>{{ player.partnerNum == 2 ? '' : player.showTeetime != '' ? player.showTeetime : player.playedHoles }}</td>
                            <td>{{ player.partnerNum == 2 ? '' : player.showTeetime != '' ? player.showTeetime : player.playedHoles == 'F' ? player.isStreicher ? '(' + player.strokes + ')' : player.strokes : '-' }}</td>
                          </tr>
                          <tr v-if="player.showScorecard" class="playerScore">
                            <td colspan="6" class="scorecard-cell">
                              <div class="scorecard-scroll">
                                <table class="playerScore scorecard-table">
                                  <thead>
                                    <tr>
                                      <th></th>
                                      <th v-for="i in 18" :key="i">{{ i }}</th>
                                      <th>+/-</th>
                                      <th>{{ $t('total') }}</th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr>
                                      <td>Par</td>
                                      <td class="small" v-for="par in player.pars" :key="par">{{ par }}</td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  <tr>
                                  <td></td>
                                  <td :class="'small ' +  getScoreClass(player.pars[index], player.scores[index])" v-for="(score, index) in player.scores" :key="index" :value="score">{{ score == 0 ? '-' : score  }}</td>
                                  <td class="small">{{ player.score }}</td>
                                  <td>{{ player.strokes }}</td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                            </div>
                          <p class="legend">
                            <span class="square eagle"></span> - Eagle oder besser ({{ getParDiff(player.pars, player.scores, -2) }})
                            <span class="square birdie"></span> - Birdie ({{ getParDiff(player.pars, player.scores, -1) }})
                            <span class="square par"></span> - Par ({{ getParDiff(player.pars, player.scores, 0) }})
                            <span class="square bogey"></span> - Bogey ({{ getParDiff(player.pars, player.scores, 1) }})
                            <span class="square doublebogey"></span> - Double Bogey ({{ getParDiff(player.pars, player.scores, 2) }})
                            <span class="square triplebogey"></span> - Triple Bogey oder schlechter ({{ getParDiff(player.pars, player.scores, 3) }})
                          </p>
                        </td>
                        </tr>
                        </template>
                        <tr class="sum">
                          <td>{{ $t('total') }}:</td>
                          <td></td>
                          <td></td>
                          <td><strong>{{ getSign(round.score) }}{{ round.score }}</strong></td>
                          <td></td>
                          <td><strong v-if="round.players.filter(f => f.playedHoles != 'F').length == 0">{{ round.strokes }}</strong></td>
                       </tr>
                      </tbody>
                    </table>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>

<ion-grid class="score-table-grid" style="color: black;" v-if="scoringMode != 3 && singleScoresRounds.length > 0 && selectedViewType == 1">
  <ion-row>
    <ion-col>
      <div ref="singleTableScroll" class="table-scroll sticky-table-scroll">
        <table class="singleRanking sticky-ranking">
          <thead>
            <tr>
              <th>{{ $t('position') }}</th>
              <th>Name</th>
              <th>Club</th>
              <th>HCPI&#8482;</th>
              <th>+/-</th>
              <th>{{ $t('thru') }}</th>
              <th v-for="round in singleScoresRoundsDisplay" :key="round">R{{ round.roundIndex }}</th>
              <th>{{ $t('total') }}</th>
            </tr>
          </thead>

          <tbody style="color: black;">
            <template v-for="player in singleScoresPlayers" :key="player">
              <tr :class="player.partnerNum == 2 ? 'teamEnd' : ''">
                <td>{{ player.partnerNum == 2 ? '' : player.rank }}</td>

                <td>
                  <img
                    style="vertical-align:middle"
                    width="16"
                    v-if="player.flag && player.flag != ''"
                    :src="require('@/assets/images/flags_iso/' + player.flag + '.png')"
                  >
                  <span style="margin-top:0px;" @click="player.showScorecard = !player.showScorecard">
                    {{ player.name }}
                  </span>
                </td>

                <td>{{ player.clubName }}</td>
                <td>{{ player.hcp }}</td>
                <td>{{ player.partnerNum == 2 ? '' : getPlusSign(player.totalScore) }}</td>
                <td>{{ player.showTeetime != '' ? player.partnerNum == 2 ? '' : player.showTeetime : player.partnerNum == 2 ? '' : player.playedHoles }}</td>
                <td v-for="(round, index) in singleScoresRoundsDisplay" :key="index">
                  {{ player.partnerNum == 2 ? '' : player.prevStrokes[index] > 0 ? player.prevStrokes[index] : getPlusSign(player.score) }}
                </td>
                <td>{{ player.showTeetime != '' ? player.partnerNum == 2 ? '' : player.showTeetime : player.partnerNum == 2 ? '' : player.prevStrokes && player.prevStrokes.length > 0 && player.prevStrokes.find(f => f == 0) ? '-' : player.totalStrokes }}</td>
              </tr>

              <tr v-if="player.showScorecard" class="playerScore">
                <td :colspan="7 + singleScoresRoundsDisplay.length" class="scorecard-cell">
                  <div class="scorecard-scroll">
                  <table class="playerScore scorecard-table">
                    <thead>
                      <tr>
                        <th></th>
                        <th v-for="i in 18" :key="i">{{ i }}</th>
                        <th>+/-</th>
                        <th>{{ $t('total') }}</th>
                        <th></th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>Par</td>
                        <td class="small" v-for="par in player.pars" :key="par">{{ par }}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>

                      <tr>
                        <td></td>
                        <td
                          :class="'small ' + getScoreClass(player.pars[index], player.scores[index])"
                          v-for="(score, index) in player.scores"
                          :key="index"
                          :value="score"
                        >
                          {{ score == 0 ? '-' : score }}
                        </td>
                        <td class="small">{{ getPlusSign(player.score) }}</td>
                        <td>{{ player.strokes }}</td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  </div>

                  <p class="legend">
                    <span class="square eagle"></span> - {{ $t('eagle') }} ({{ getParDiff(player.pars, player.scores, -2) }})
                    <span class="square birdie"></span> - {{ $t('birdie') }} ({{ getParDiff(player.pars, player.scores, -1) }})
                    <span class="square par"></span> - {{ $t('par') }} ({{ getParDiff(player.pars, player.scores, 0) }})
                    <span class="square bogey"></span> - {{ $t('bogey') }} ({{ getParDiff(player.pars, player.scores, 1) }})
                    <span class="square doublebogey"></span> - {{ $t('doublebogey') }} ({{ getParDiff(player.pars, player.scores, 2) }})
                    <span class="square triplebogey"></span> - {{ $t('triplebogey') }} ({{ getParDiff(player.pars, player.scores, 3) }})
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>

        <ion-grid style="color: black;" v-if="scoringMode == 3"> <!-- Matchplay View -->
          <ion-row>
            <ion-col>
              <table class="ranking matchplay">
                <colgroup>
                  <col width="*">
                  <col width="100">
                  <col width="100">
                  <col width="100">
                  <col width="*">
                </colgroup>
                <tbody>
                  <tr>
                  <th style="text-align:right">Spieler</th>
                  <th style="text-align: center">Punkte</th>
                  <th style="text-align: center">Ergebnis</th>
                  <th style="text-align: center">Punkte</th>
                  <th style="text-align:left">Spieler</th>
                  </tr>
                  <template v-for="player in singleScoresPlayers" :key="player">
                    <tr style="cursor: pointer;" @click="player.showScorecard = !player.showScorecard">
                      <td style="text-align:right">
                      <a >{{ player.name }} <span style="font-size: smaller">({{ player.hcp }})</span></a><br>
                      <span style="font-size: smaller">{{ player.clubName }}</span>
                      </td>
                      <td style="text-align: center;">
                      <a>{{ player.score }}</a>
                      </td>
                      <td style="text-align: center;">
                      <a>{{ player.scoreLabel }}<br v-if="player.isCompleted != ''">{{ player.isCompleted }}
                      </a>
                      </td>
                      <td style="text-align: center;">
                      <a>{{ player.scoreOpponent }}</a>
                      </td>
                      <td>
                        <a >{{ player.opponentName }} <span style="font-size: smaller">({{ player.opponentHcp }})</span></a><br>
                      <span style="font-size: smaller">{{ player.opponentClubName }}</span>
                      </td>
                    </tr>
                    <tr v-if="player.showScorecard" class="playerScore">
                      <td colspan="5">
                        <table class="playerScore matchplay">
                          <tbody>
                            <tr>
                              <td>Loch</td>
                              <td v-for="i in 18" :key="i">{{ i }}</td>
                            </tr>
                            <tr>
                              <td>{{ player.name }}</td>
                              <td v-for="label in player.scoresLabel" :key="label">{{ label != 'AS' && label != '--' ? label : '' }}</td>
                            </tr>
                            <tr class="as">
                              <td></td>
                              <td v-for="label in player.scoresLabel" :key="label">{{ label == 'AS' || label == '--' ? label : '' }}</td>
                            </tr>
                            <tr>
                              <td>{{ player.opponentName }}</td>
                              <td v-for="label in player.scoresLabelOpponent" :key="label">{{ label != 'AS' && label != '--' ? label : '' }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </template>
              </tbody>
              </table>
            </ion-col>
          </ion-row>
        </ion-grid>

        <div style="max-width: 1024px; width: auto; margin:0 auto;">
                <div><img width="1024" :src="footerImg"></div>
              </div>                
              <div style="font-size:small; color: black; margin:0 auto;">
                <div style="margin: 10px;"><a href="https://www.clubinone.de" target="_blank">Powered by CLUB IN ONE</a></div>
              </div>                

      </ion-content>
  </ion-page>
</template>

<script>

import { IonPage, IonContent, IonGrid, IonRow, IonCol, loadingController  } from '@ionic/vue';
import { defineComponent, computed, watch, ref, getCurrentInstance, nextTick } from 'vue';
import { useQuery } from '@vue/apollo-composable'
import getDGVNavigationQueryFile from '../graphql/getDGVNavigation.query.gql'
import getDGVTeamScoreQueryFile from '../graphql/getDGVTeamScore.query.gql'
import getDGVSingleScoreQueryFile from '../graphql/getDGVSingleScore.query.gql'
import {  } from 'ionicons/icons';
import VueScriptComponent from 'vue-script-component'
import { useRoute, useRouter } from 'vue-router';
require('@/assets/images/arrow.gif')
import MarqueeText from 'vue-marquee-text-component'

export default defineComponent({
  name: 'Home',
  components: {
    VueScriptComponent, IonPage, IonContent, IonGrid, IonRow, IonCol, MarqueeText
  },
  data() {
    return {
    }
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    let loadingSpinner = null
    let isLoaded = ref(false)
    let selectedNav = ref(undefined)
    let selectedMatchDay = ref(0)
    let selectedViewType = ref(-1)
    let selectedRefresh = ref(1)
    let selectedSingleRound = ref(0)
    let singleScoresRoundsDisplay = ref([])

    let singleTableScroll = ref(null)

    const scrollSingleTableToRight = async (tries = 8) => {
      await nextTick()

      const run = (leftTries) => {
        requestAnimationFrame(() => {
          const el = singleTableScroll.value
          if (!el) return

          const maxScroll = el.scrollWidth - el.clientWidth

          if (maxScroll > 0) {
            el.scrollLeft = maxScroll
            return
          }

          if (leftTries > 0) {
            setTimeout(() => run(leftTries - 1), 80)
          }
        })
      }

      run(tries)
    }

    const app = getCurrentInstance()
    const changeLanguage = app.appContext.config.globalProperties.$changeLanguage

    const { result: getDGVNavigationResult, refetch: getDGVNavigationRefetch } = useQuery(getDGVNavigationQueryFile, () => ({ tid: parseInt(route.params.tid) }), () => ({ fetchPolicy: 'no-cache', enabled: route.params.tid != undefined } ))

    const { result: getDGVTeamScoreResult, refetch: getDGVTeamScoreRefetch, loading: getDGVTeamScoreLoading } = useQuery(getDGVTeamScoreQueryFile, () => ({ matchDayId: parseFloat(selectedMatchDay.value), viewType: selectedViewType.value }), () => ({ fetchPolicy: 'no-cache', pollInterval: selectedRefresh.value == 0 ? 0 : 60000*5,  enabled: selectedMatchDay.value != 0 && selectedViewType.value == 0 } ))

    const { result: getDGVSingleScoreResult, refetch: getDGVSingleScoreRefetch, loading: getDGVSingleScoreLoading } = useQuery(getDGVSingleScoreQueryFile, () => ({ matchDayId: parseFloat(selectedMatchDay.value), viewType: selectedViewType.value, roundId: parseInt(selectedSingleRound.value) }), () => ({ fetchPolicy: 'no-cache', pollInterval: selectedRefresh.value == 0 ? 0 : 60000*5, enabled: selectedMatchDay.value != 0 && selectedViewType.value == 1 } ))


    const refreshSelect = [{ id: 0, name: 'Nein' }, { id: 1, name: '5 Minuten', selected: true }]
    const adLinkTop = computed(() => getDGVNavigationResult.value?.getDGVNavigation.adLinkTop ?? '')
    const scoringMode = computed(() => getDGVNavigationResult.value?.getDGVNavigation.scoringMode ?? '')
    const leaguesNav = computed(() => getDGVNavigationResult.value?.getDGVNavigation.leaguesNav ?? '')
    const viewType = computed(() => getDGVNavigationResult.value?.getDGVNavigation.viewType ?? '')
    const matchDays = computed(() => getDGVNavigationResult.value?.getDGVNavigation.matchDays ?? '')
    const footerImg = computed(() => getDGVNavigationResult.value?.getDGVNavigation.footerImg ?? '')
    const logoImg = computed(() => getDGVNavigationResult.value?.getDGVNavigation.logoImg ?? '')
    const teamScores = computed(() => getDGVTeamScoreResult.value?.getDGVTeamScore.teams ?? [])
    const singleScoresPlayers = computed(() => getDGVSingleScoreResult.value?.getDGVSingleScore.players ?? [])
    const singleScoresRounds = computed(() => getDGVSingleScoreResult.value?.getDGVSingleScore.rounds ?? [])
    const lang = computed(() => getDGVNavigationResult.value?.getDGVNavigation.lang ?? '')
    const tickerTeam = computed(() => getDGVTeamScoreResult.value?.getDGVTeamScore.currentTicker ?? '')
    const tickerSingle = computed(() => getDGVSingleScoreResult.value?.getDGVSingleScore.currentTicker ?? '')
    const currentTicker = computed({
        get() {
          if (tickerTeam.value && tickerTeam.value != '') return tickerTeam.value
          if (tickerSingle.value && tickerSingle.value != '') return tickerSingle.value
          return ''
        },
      })

    watch(singleScoresRoundsDisplay, () => {
      scrollSingleTableToRight()
    }, { immediate: true })

    watch(viewType, (newVal, oldVal) => {
      // Einzel is in list
      if (newVal.find(f => f.type_id == 1))
        selectedViewType.value = 1
      else
        selectedViewType.value = 0
    })

    watch(lang, (newVal, oldVal) => {
      changeLanguage(newVal)
    })


    watch(matchDays, (newVal, oldVal) => {
      selectedMatchDay.value =  newVal.find(f => f.selected == true).id
    })
    watch(singleScoresRounds, (newVal, oldVal) => {
      if (newVal && newVal.lenght > 0 && selectedSingleRound.value == 0 || !newVal.find(f => f.id == selectedSingleRound.value)) {
        selectedSingleRound.value =  newVal.find(f => f.selected == true).id
      }
    })

    watch(selectedNav, (newVal, oldVal) => {
      if (oldVal != undefined && newVal != oldVal) {
        isLoaded.value = false
        router.push('/score/' + newVal + '/' + route.params.pid)
        //getDGVNavigationRefetch()
      }
    })

    watch(selectedMatchDay, (newVal, oldVal) => {
      isLoaded.value = false
    })
    watch(selectedViewType, (newVal, oldVal) => {
      isLoaded.value = false
    })
    watch(selectedSingleRound, (newVal, oldVal) => {
      const roundIndex = singleScoresRounds.value.find(f => f.id == newVal).roundIndex
      singleScoresRoundsDisplay.value = singleScoresRounds.value.filter(f => f.roundIndex <= roundIndex)
      if (oldVal != 0)
        isLoaded.value = false
    })

    watch(getDGVSingleScoreLoading, (newLoading, pervLoading)=> {
      if (!newLoading) {
        scrollSingleTableToRight()
      }

      if (!newLoading && loadingSpinner != null) {
          isLoaded.value = true
          loadingSpinner.dismiss()
          loadingSpinner = null
          return
      }
      else if (!isLoaded.value && newLoading) {
        isLoaded.value = true
        loadingController.create().then(res => {
              loadingSpinner = res
              loadingSpinner.present().then(async () => { 
                if (!getDGVSingleScoreLoading.value && loadingSpinner) {
                  loadingSpinner.dismiss() 
                  loadingSpinner = null
                }
              })
            }).catch(err => { })
      }
    })
    
    watch(getDGVTeamScoreLoading, (newLoading, pervLoading)=> {
      if (!newLoading && loadingSpinner != null) {
          isLoaded.value = true
          loadingSpinner.dismiss()
          loadingSpinner = null
          return
      }
      else if (!isLoaded.value && newLoading) {
        isLoaded.value = true
        loadingController.create().then(res => {
              loadingSpinner = res
              loadingSpinner.present().then(async () => { 
                if (!getDGVTeamScoreLoading.value && loadingSpinner) {
                  loadingSpinner.dismiss() 
                  loadingSpinner = null
                }
              })
            }).catch(err => { })
      }
    })
    
    return {
      singleTableScroll, adLinkTop, leaguesNav, selectedNav, viewType, selectedViewType, matchDays, selectedMatchDay, selectedRefresh, refreshSelect, getDGVSingleScoreRefetch, getDGVTeamScoreRefetch, teamScores, singleScoresPlayers, singleScoresRounds, currentTicker, getDGVTeamScoreLoading, getDGVSingleScoreLoading, isLoaded, selectedSingleRound, footerImg, logoImg, scoringMode, singleScoresRoundsDisplay, lang
    }
  },
  methods: {
    getParDiff(pars, scores, value) {
      let count = 0
      let parDiffCount = 0
      for (const par of pars) {
        if (value != 3 && scores[count] - par  == value)
          parDiffCount++
        if (value == 3 && scores[count] - par  >= value)
          parDiffCount++
        count++
      }
      return parDiffCount
    },
    getScoreClass(par, score) {
      if (score - par == 0)
        return 'par'
      if (score - par == -1)
        return 'birdie'
      if (score > 0 && score - par <= -2)
        return 'eagle'
      if (score - par == 1)
        return 'bogey'
      if (score - par == 2)
        return 'doublebogey'
      if (score - par > 2)
        return 'triplebogey'
    },
    getSign(score) {
      return score == 0 ? '' : score > 0 ? '+' : ''
    },
    getPlusSign(score) {
      if (score == 0)
        return 'Par'
      return score > 0 ? '+' + score : score
    },
    refreshScore() {
      this.isLoaded = false
      if (this.selectedViewType == 0)
        this.getDGVTeamScoreRefetch()
      else
        this.getDGVSingleScoreRefetch()
    }
  }
});

if (document.location.search.match(/type=embed/gi)) {
  window.parent.postMessage("resize", "*");
}

</script>

<style scoped>

.gender-select {
  display: block;
  width: auto !important;
  min-width: 105px;
  max-width: 105px;
  margin: 8px 0 0 0;
  padding: 6px 16px;
  height: 40px;
  border-radius: 999px;
  font-weight: 600;
}

.refresh-bar {
  float: right;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  margin-right: 10px;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  color: #111827;
  font-size: 13px;
}

.refresh-label {
  color: #4b5563;
  white-space: nowrap;
}

.refresh-select {
  height: 32px;
  margin: 0;
  padding: 4px 28px 4px 12px;
  border: 1px solid #d1d5db;
  border-radius: 999px;
  background: #f9fafb;
  color: #111827;
  font-size: 13px;
  font-weight: 600;
}

.refresh-button {
  width: 38px;
  min-width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid #d1d5db;
  border-radius: 50%;
  background: #f9fafb;
  color: #4b5563;
  font-size: 21px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  box-shadow: none;
}

.refresh-button:hover {
  background: #eef2f7;
  color: #111827;
}

.refresh-button:active,
.refresh-button:focus,
.refresh-button:focus-visible {
  background: #e5e7eb;
  color: #111827;
  outline: none;
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.25);
}

.table-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.score-header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  margin: 15px 0 45px;
  color: black;
}

.tournament-title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 0 15px;
}

.tournament-logo {
  width: 60px;
  object-fit: contain;
}

.tournament-title {
  margin: 0;
  font-weight: 400;
  line-height: 1.15;
  text-align: center;
  max-width: 95vw;
  word-break: normal;
  overflow-wrap: normal;
  white-space: normal;
}

.score-controls {
  order: 2;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 5px;
}

.round-select {
  display: block;
  width: auto !important;
  min-width: 105px;
  max-width: 105px;
  margin: 8px 0 0 0;
  padding: 6px 16px;
  height: 30px;
  border-radius: 999px;
  font-weight: 600;
}


@media (max-width: 768px) {
  table.singleRanking {
    width: 100%;
    table-layout: fixed;
  }

  .col-position { width: 42px; }
  .col-name { width: 110px; }
  .col-club { width: 120px; }
  .col-hcp { width: 50px; }
  .col-score { width: 46px; }
  .col-thru { width: 48px; }
  .col-round { width: 44px; }
  .col-total { width: 58px; }

  table.singleRanking > thead > tr > th,
  table.singleRanking > tbody > tr > td {
    font-size: 13px;
    padding: 5px 6px;
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    vertical-align: middle;
  }

  table.singleRanking > thead > tr > th:first-child,
  table.singleRanking > tbody > tr > td:first-child,
  table.singleRanking > thead > tr > th:nth-child(4),
  table.singleRanking > tbody > tr > td:nth-child(4),
  table.singleRanking > thead > tr > th:nth-child(5),
  table.singleRanking > tbody > tr > td:nth-child(5),
  table.singleRanking > thead > tr > th:nth-child(6),
  table.singleRanking > tbody > tr > td:nth-child(6),
  table.singleRanking > thead > tr > th:nth-last-child(-n + 3),
  table.singleRanking > tbody > tr > td:nth-last-child(-n + 3) {
    text-align: center !important;
    white-space: nowrap;
  }

  table.singleRanking > thead > tr > th:nth-child(2),
  table.singleRanking > tbody > tr > td:nth-child(2),
  table.singleRanking > thead > tr > th:nth-child(3),
  table.singleRanking > tbody > tr > td:nth-child(3) {
    text-align: left !important;
    white-space: normal;
  }
}

tr td:first-child {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px
}

tr td:last-child {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px
}

.cf:after {
    content: "";
    display: table;
    clear: both;
}

div.wrap,
div.error {
    padding: 7px;
}

div.wrap.noTop {
    padding-top: 0;
}

div.wrap ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

div.wrap > ul > li {
    padding-right: 4px;
    padding-bottom: 15px;
    width: 25%;
    float: left;
}

div.wrap ul li h2 {
    font: bold 1.5em/1.5 "Roboto", sans-serif;
    padding-bottom: 3px;
    border-bottom: 1px solid;
    margin: 0;
}

div.wrap > ul > li > ul {
    padding-right: 30px;
    padding-top: 7px;
}

div.wrap > ul > li > ul > li {
    padding: 10px 5px 10px 1em;
    font-size: 1.2em;
    font-weight: 600;
    cursor: pointer;
}

div.wrap > ul > li > ul > li > ul {
    padding-left: 20px;
}

div.wrap > ul > li > ul > li > ul {
    margin-top: 5px;
    padding-top: 5px;
    border-top: solid 2px;
    display: none;
}

div.wrap > ul > li > ul > li > ul > li {
    padding: 5px 0;
}

div.wrap ul a {
    text-decoration: none;
    font-weight: normal;
}

div.wrap ul a:hover {
    text-decoration: underline;
}

div.refresh {
    float: right;
    line-height: 1;
    padding-top: 7px;
}

div.refresh select {
    font-size: 12px;
    margin: 0;
    width: 100px;
}

div.refresh a {
    display: inline-block;
    cursor: pointer;
}

div.filter {
    float: left;
    max-width: 400px;
    padding-left: 7px;
}

div.filter a {
    text-decoration: none;
    background: transparent url('~@/assets/images/arrow.gif') no-repeat right center;
    padding-right: 20px;
}

div.filter select {
    display: block;
    width: 100%;
}

ion-content {
    margin: 0;
    padding: 0;
    font: normal 12px/1.3 Arial, Verdana, sans-serif !important;
    --ion-background-color: white !important;
}

select {
    margin-top: 7px;
    font-size: 1.2em;
    font-weight: 600;
    height: 30px;
    max-width: 100%;
    padding: 4px 6px;
    border: 1px solid;
}

span.square {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: solid 1px;
    margin-left: 20px;
    margin-bottom: -4px;
}

p.legend {
    font-size: 12px;
    text-align: right;
    padding-right: 20px;
    margin-bottom: 15px;
}

p.right {
    text-align: right;
}

img {
    max-width: 100%;
    height: auto;
}

div.controls {
    margin: 0 0 20px 0;
}

div.head {
    font-size: 19px;
    font-weight: bold;
    border-bottom: 1px solid;
}

div.head span {
    display: inline-block;
}

div.head span.rank {
    width: 50px;
    padding-left: 5px;
}

div.head span.score {
    width: 70px;
    float: right;
    text-align: center;
}

.ticker-text {
    height: 150%;
    font-size: 25px;
    color: red;
}

div.roundInfo {
    padding: 16px 0 5px 0;
    font-size: 18px;
}

table.ranking span,
table.singleRanking span {
    text-decoration: none;
    cursor: pointer;
}

table.ranking tr.sum > td {
    border-top: solid 2px;
}

table.ranking,
table.singleRanking {
    width: 100%;
    table-layout: auto;
    margin-bottom: 30px;
}

table.ranking tr,
table.singleRanking tr {
    height: 30px;
}

table.ranking > thead > tr > th,
table.singleRanking > thead > tr > th {
    padding: 3px 5px;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    border: solid 1px;
    border-top: none;
    border-bottom-width: 3px;
    width: 75px;
}

table.ranking > thead > tr > th:nth-child(1),
table.ranking > thead > tr > th:nth-child(2),
table.singleRanking > thead > tr > th:nth-child(2),
table.singleRanking > thead > tr > th:nth-child(3),
table.singleRanking > tbody > tr > td:nth-child(2),
table.singleRanking > tbody > tr > td:nth-child(3) {
    text-align: left !important;
}

table.ranking > thead > tr > th:first-child,
table.ranking > tbody > tr > td:first-child,
table.singleRanking > thead > tr > th:first-child,
table.singleRanking > tbody > tr > td:first-child {
    border-left: none;
}

table.ranking > thead > tr > th:last-child,
table.ranking > tbody > tr > td:last-child,
table.singleRanking > thead > tr > th:last-child,
table.singleRanking > tbody > tr > td:last-child {
    border-right: none;
}

table.ranking > tbody > tr > td,
table.singleRanking > tbody > tr > td {
    font-size: 14px;
    padding: 3px 5px;
    border: solid 1px;
    text-align: center;
}

table.ranking.matchplay > tbody > tr > td {
    text-align: left;
}

table.ranking > tbody > tr > td:nth-child(1),
table.ranking > tbody > tr > td:nth-child(2) {
    text-align: left;
}

table.ranking tr.sum > td {
    border-top: solid 2px;
}

table.ranking > tbody > tr.teamEnd > td,
table.singleRanking > tbody > tr.teamEnd > td {
    border-bottom: solid 3px;
}

table.ranking tr.playerScore,
table.singleRanking tr.playerScore {
    display: table-row;
}

table.ranking tr.playerScore > td,
table.singleRanking tr.playerScore > td {
    padding: 5px 3px;
}

table.ranking a,
table.singleRanking a {
    text-decoration: none;
}

table.ranking a:hover,
table.singleRanking a:hover {
    text-decoration: underline;
}

table.ranking > tbody > tr > td {
    font-size: 14px;
    padding: 3px 5px;
    border: solid 1px;
    text-align: center;
}

table.playerScore {
    width: 100%;
}

table.playerScore thead tr th {
    font-weight: normal;
    border: solid 1px;
    border-top: none;
    border-bottom-width: 3px;
    text-align: center;
    padding: 3px 5px;
}

table.playerScore > tbody > tr > td {
    border: solid 1px;
    text-align: center;
    padding: 3px 5px;
}

table.playerScore > thead > tr > th:first-child,
table.playerScore > tbody > tr > td:first-child {
    border-left: none;
}

table.playerScore > thead > tr > th:last-child,
table.playerScore > tbody > tr > td:last-child {
    border-right: none;
}

table.playerScore td.small,
table.playerScore th.small {
    width: 32px;
}

table.playerScore tr :nth-child(2) {
    width: 40px;
}

table.playerScore tr :nth-child(21) {
    width: 58px;
}

table.playerScore tbody tr td {
}

table.playerScore tbody tr td:first-child {
    font-weight: normal !important;
    text-align: right;
}

table.playerScore tbody tr:first-child td {
    font-weight: bold;
}

table.playerScore.matchplay tr td {
    width: 50px;
}

table.playerScore.matchplay tr td:first-child {
    width: auto;
}

table.playerScore.matchplay tr.as td {
}

.eagle {
    background: #ff9050 !important;
}

.birdie {
    background: #ff7070 !important;
}

.par {
    background: lightgray !important;
}

.bogey {
    background: #80bb80 !important;
}

.doublebogey {
    background: #a0a0cc !important;
}

.triplebogey {
    background: #60608c !important;
}

span.square {
    display: inline-block;
    width: 18px;
    height: 18px;
    border: solid 1px;
    margin-left: 20px;
    margin-bottom: -4px;
}

p.legend {
    font-size: 12px;
    text-align: right;
    padding-right: 20px;
    margin-bottom: 15px;
}

p.right {
    text-align: right;
}

img {
    max-width: 100%;
    height: auto;
}



/* Modern page look */
ion-content {
  --ion-background-color: #f3f6fb !important;
  font-family: Inter, Arial, Verdana, sans-serif !important;
}

ion-grid {
  max-width: 1180px;
  margin: 0 auto;
  background: transparent;
}

/* Header card */
.score-header {
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e5e7eb;
  border-radius: 28px;
  padding: 28px 18px 32px;
  margin: 14px 12px 34px;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.08);
}

.tournament-logo {
  width: 60px;
  max-width: 70vw;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.08));
}

.tournament-title {
  color: #111827;
  font-weight: 500;
  letter-spacing: -0.03em;
}

/* Selects */
select,
.refresh-select,
.round-select {
  appearance: none;
  border: 1px solid #d1d5db !important;
  background: #ffffff;
  color: #111827;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.round-select {
  border-radius: 999px;
  padding: 0px 10px;
  min-width: 105px;
  height: 30px;
  font-weight: 600;
}

/* Refresh */
.refresh-bar {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e5e7eb;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.1);
  backdrop-filter: blur(8px);
}

.refresh-button {
  transition: transform 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
}

.refresh-button:hover {
  transform: rotate(20deg);
}

.refresh-button:active {
  transform: scale(0.94) rotate(40deg);
}

/* Tables */
.table-scroll {
  width: calc(100% - 24px);
  margin: 0 12px 28px;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
  overflow-x: auto;
}

@media (max-width: 768px) {
  .table-scroll {
    width: calc(100% - 16px);
    margin: 0 8px 24px;
  }
}

table.ranking,
table.singleRanking {
  margin-bottom: 0;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
}

table.ranking > thead > tr > th,
table.singleRanking > thead > tr > th {
  background: #f8fafc;
  color: #111827;
  border-color: #e5e7eb;
  border-top: none;
  border-bottom: 2px solid #111827;
  font-size: 13px;
  font-weight: 700;
  padding: 10px 8px;
}

table.ranking > tbody > tr > td,
table.singleRanking > tbody > tr > td {
  border-color: #e5e7eb;
  padding: 9px 8px;
  color: #111827;
  background: #ffffff;
}

table.ranking > tbody > tr:nth-child(even) > td,
table.singleRanking > tbody > tr:nth-child(even) > td {
  background: #f9fafb;
}

table.ranking > tbody > tr:hover > td,
table.singleRanking > tbody > tr:hover > td {
  background: #eef6ff;
}

/* Team heading */
div.head {
  margin: 18px 12px 8px;
  padding: 12px 14px;
  background: #111827;
  color: #ffffff;
  border-radius: 16px;
  border-bottom: none;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.18);
}

/* Round info */
div.roundInfo {
  margin: 8px 12px;
  padding: 8px 12px;
  color: #374151;
  font-weight: 600;
}

/* Ticker */
.ticker-text {
  margin: 0 12px 18px;
  padding: 10px 14px;
  border-radius: 14px;
  background: #fff7ed;
  color: #c2410c;
  font-weight: 600;
}

/* Footer */
a {
  color: #2563eb;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  ion-grid {
    max-width: 100%;
  }

  .refresh-bar {
    float: none;
    width: fit-content;
    max-width: calc(100vw - 24px);
    margin: 0 auto 16px;
  }

  .refresh-label {
    display: none;
  }

  .score-header {
    margin: 10px 8px 24px;
    padding: 22px 12px 26px;
    border-radius: 22px;
  }

  .tournament-logo {
    width: 60px;
  }

  .tournament-title {
    font-size: 18px;
  }

  .table-scroll {
    margin: 0 8px 24px;
    border-radius: 14px;
  }
}


/* Sticky Single Ranking */
.score-table-grid {
  max-width: 1180px;
  margin: 0 auto;
  background: transparent;
}

.sticky-table-scroll {
  width: calc(100% - 24px);
  margin: 0 12px 28px;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: auto;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
}

table.sticky-ranking {
  width: 100% !important;
  min-width: 980px !important;
  table-layout: fixed !important;
  border-collapse: separate !important;
  border-spacing: 0 !important;
  overflow: visible !important;
}

@media (min-width: 1024px) {
  .sticky-table-scroll {
    overflow-x: hidden !important;
  }

  table.sticky-ranking {
    min-width: 100% !important;
    width: 100% !important;
  }

  .sticky-ranking > thead > tr > th:nth-child(n + 4),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(n + 4) {
    width: auto !important;
    min-width: 0 !important;
    max-width: none !important;
  }
}

/* NUR Haupttabelle, nicht Scorecard */
.sticky-ranking > thead > tr > th,
.sticky-ranking > tbody > tr:not(.playerScore) > td {
  box-sizing: border-box !important;
  background-clip: padding-box;
}

/* Desktop */
.sticky-ranking > thead > tr > th:nth-child(1),
.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(1) {
  position: sticky !important;
  left: 0 !important;
  width: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
  z-index: 40 !important;
}

.sticky-ranking > thead > tr > th:nth-child(2),
.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(2) {
  position: sticky !important;
  left: 72px !important;
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  z-index: 40 !important;
}

.sticky-ranking > thead > tr > th:nth-child(3),
.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(3) {
  position: sticky !important;
  left: 311px !important;
  width: 100px !important;
  min-width: 100px !important;
  max-width: 100px !important;
  z-index: 40 !important;
  box-shadow: 8px 0 12px rgba(15, 23, 42, 0.12);
}

.sticky-ranking > thead > tr > th:nth-child(n + 4),
.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(n + 4) {
  width: 30px !important;
  min-width: 30px !important;
  max-width: 30px !important;
}

.sticky-ranking > thead > tr > th {
  z-index: 90 !important;
  background: #f8fafc !important;
}

.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(1),
.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(2),
.sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(3) {
  background: #ffffff !important;
}

.sticky-ranking > tbody > tr:nth-child(even):not(.playerScore) > td:nth-child(1),
.sticky-ranking > tbody > tr:nth-child(even):not(.playerScore) > td:nth-child(2),
.sticky-ranking > tbody > tr:nth-child(even):not(.playerScore) > td:nth-child(3) {
  background: #f9fafb !important;
}

/* Scorecard komplett aus Sticky-Logik raus */
.sticky-ranking > tbody > tr.playerScore > td.scorecard-cell {
  position: static !important;
  left: auto !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  padding: 0 !important;
  z-index: auto !important;
  background: #ffffff !important;
}

.scorecard-scroll {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  background: #ffffff;
  padding: 10px 6px 14px;
}

.sticky-ranking .scorecard-table {
  width: max-content !important;
  min-width: 760px !important;
  table-layout: fixed !important;
  border-collapse: collapse !important;
  margin: 0 !important;
}

.sticky-ranking .scorecard-table th,
.sticky-ranking .scorecard-table td {
  position: static !important;
  left: auto !important;
  z-index: auto !important;
  width: 38px !important;
  min-width: 38px !important;
  max-width: 38px !important;
  white-space: nowrap !important;
  text-align: center !important;
  padding: 6px 4px !important;
}

.sticky-ranking .scorecard-table th:first-child,
.sticky-ranking .scorecard-table td:first-child {
  width: 70px !important;
  min-width: 70px !important;
  max-width: 70px !important;
  text-align: right !important;
}

.sticky-ranking tr.playerScore .legend {
  min-width: 760px;
  text-align: center;
  white-space: normal;
  margin: 12px 0 10px;
}

/* Mobile */
@media (max-width: 768px) {
  .sticky-table-scroll {
    width: calc(100% - 16px);
    margin: 0 8px 24px;
  }

  table.sticky-ranking {
    min-width: 840px !important;
  }

  .sticky-ranking > thead > tr > th:nth-child(1),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(1) {
    left: 0px !important;
    width: 38px !important;
    min-width: 38px !important;
    max-width: 38px !important;
  }

  .sticky-ranking > thead > tr > th:nth-child(2),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(2) {
    left: 46px !important;
    width: 95px !important;
    min-width: 95px !important;
    max-width: 95px !important;
  }

  .sticky-ranking > thead > tr > th:nth-child(3),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(3) {
    position: static !important;
    left: auto !important;
    width: 120px !important;
    min-width: 120px !important;
    max-width: 120px !important;
    box-shadow: none !important;
  }

  .sticky-ranking > thead > tr > th:nth-child(n + 4),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(n + 4) {
    width: 72px !important;
    min-width: 72px !important;
    max-width: 72px !important;
  }
}

/* Moderne Scorecard */
.scorecard-scroll {
  border-top: 1px solid #e5e7eb;
  background: linear-gradient(180deg, #f8fafc 0%, #eef6ff 100%);
}

.sticky-ranking .scorecard-table {
  background: #ffffff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
}

.sticky-ranking .scorecard-table th {
  background: #111827 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  border-color: #374151 !important;
}

.sticky-ranking .scorecard-table td {
  background: #ffffff;
  border-color: #e5e7eb !important;
  font-weight: 600;
}

.sticky-ranking .scorecard-table tbody tr:first-child td {
  background: #f1f5f9 !important;
  color: #334155;
}

.sticky-ranking .scorecard-table td.eagle,
.sticky-ranking .scorecard-table td.birdie,
.sticky-ranking .scorecard-table td.par,
.sticky-ranking .scorecard-table td.bogey,
.sticky-ranking .scorecard-table td.doublebogey,
.sticky-ranking .scorecard-table td.triplebogey {
  color: #111827;
  font-weight: 800;
}

/* Scorecard Footer / Legend integriert */
.sticky-ranking tr.playerScore .legend {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px 16px;

  margin: 0;
  padding: 12px 14px;

  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
  border-radius: 0 0 14px 14px;

  font-size: 13px;
  color: #374151;
}

/* einzelne Items */
.sticky-ranking tr.playerScore .legend span {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

/* farbige Kästchen moderner */
.sticky-ranking tr.playerScore .legend .square {
  width: 14px;
  height: 14px;
  border-radius: 4px;
  border: none;
  margin: 0;
  box-shadow: 0 1px 2px rgba(0,0,0,0.15);
}

/* Scorecard + Footer als Einheit */
.sticky-ranking .scorecard-table {
  border-radius: 14px 14px 0 0;
}

/* Desktop: fixe Score-Spalten, Name füllt Rest */
@media (min-width: 769px) {
  table.sticky-ranking {
    width: 100% !important;
    min-width: 0 !important;
    table-layout: fixed !important;
  }

  .sticky-ranking > thead > tr > th,
  .sticky-ranking > tbody > tr:not(.playerScore) > td {
    box-sizing: border-box !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
  }

  /* Rank fix */
  .sticky-ranking > thead > tr > th:nth-child(1),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(1) {
    width: 70px !important;
    min-width: 70px !important;
    max-width: 70px !important;
    left: 0 !important;
  }

  /* Name dynamisch */
  .sticky-ranking > thead > tr > th:nth-child(2),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(2) {
    width: auto !important;
    min-width: 120px !important;
    max-width: none !important;
    left: 70px !important;
  }

  /* Club fix */
  .sticky-ranking > thead > tr > th:nth-child(3),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(3) {
    width: 180px !important;
    min-width: 180px !important;
    max-width: 180px !important;
    left: auto !important;
  }

  /* alle Spalten ab HCPI fix 30px */
  .sticky-ranking > thead > tr > th:nth-child(n + 4),
  .sticky-ranking > tbody > tr:not(.playerScore) > td:nth-child(n + 4) {
    width: 60px !important;
    min-width: 60px !important;
    max-width: 60px !important;
    padding-left: 2px !important;
    padding-right: 2px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: clip !important;
  }
}

</style>